import { FC, useState } from "react";
import { getEntryUrl, translate } from "@kaltura/mediaspace-shared-utils";
import TopBanner from "../top-banner/TopBanner";

export interface AttendeeTopBannerProps {
    entryName: string;
    entryId: string;
}

export const AttendeeTopBanner: FC<AttendeeTopBannerProps> = ({ entryName, entryId }) => {
    // State for banner visibility
    const [isTopBannerVisible, setIsTopBannerVisible] = useState(true);

    if (!isTopBannerVisible) return null;

    return (
        <TopBanner
            bannerText={translate("This is the attendee view for: %1", [entryName])}
            buttonText={translate("Studio view")}
            buttonUrl={getEntryUrl(entryId, undefined, entryName)}
            buttonTarget={"_self"}
            onClose={() => setIsTopBannerVisible(false)}
            ctaAnalyticsValue={"Studio View"}
            closeButtonAnalyticsValue={"Close attendee view banner"}
        />
    );
};

export default AttendeeTopBanner;
